import React, { useEffect, useState } from 'react';
import { Check, Loader2, X } from 'lucide-react';
import { subscribeToDownloadNotifications, dismissDownloadNotification } from '../utils/downloadNotifications';
import '../styles/DownloadStack.css';

const BASE_BOTTOM = 20;
const TRAY_GAP = 8;

export const DownloadStack = () => {
    const [downloads, setDownloads] = useState([]);
    const [bottomOffset, setBottomOffset] = useState(BASE_BOTTOM);

    useEffect(() => subscribeToDownloadNotifications(setDownloads), []);

    // Keep the stack sitting just above the upload tray and the floating
    // feedback/agent buttons whenever either is visible.
    useEffect(() => {
        if (downloads.length === 0) return undefined;

        const updateOffset = () => {
            let offset = BASE_BOTTOM;
            ['.upload-tray', '.global-floating-actions'].forEach(selector => {
                const element = document.querySelector(selector);
                if (element) {
                    const top = element.getBoundingClientRect().top;
                    offset = Math.max(offset, window.innerHeight - top + TRAY_GAP);
                }
            });
            setBottomOffset(offset);
        };

        updateOffset();
        const intervalId = window.setInterval(updateOffset, 400);
        return () => window.clearInterval(intervalId);
    }, [downloads.length]);

    if (downloads.length === 0) return null;

    return (
        <div className="download-stack" style={{ bottom: bottomOffset }}>
            {downloads.map(item => (
                <div key={item.id} className="download-stack-item fade-in">
                    <span className="download-stack-name" title={item.fileName}>
                        {item.status === 'loading' ? 'Preparing' : 'Download started'}: {item.fileName}
                    </span>
                    <span className={`download-stack-icon${item.status === 'loading' ? '' : ' completed'}`}>
                        {item.status === 'loading'
                            ? <Loader2 size={16} className="download-stack-spinner" />
                            : <Check size={16} />}
                    </span>
                    <X
                        size={14}
                        className="download-stack-close"
                        onClick={() => dismissDownloadNotification(item.id)}
                    />
                </div>
            ))}
        </div>
    );
};

export default DownloadStack;
